import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE01005S = () => {

  const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
  const toggleDropdown = (e) => {
      e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
      setIsOpen(!isOpen); // 상태 토글
  };

  return (
    <CommonLayout>
      <CommonMenu />
      <div id="contents" className="container">
        <div className="sub-title bg-type02">
          <h2>사업분야</h2>
        </div>

        <div className="location_wrap">
          <ul className="depth1">
            <li>
              <Link to="/">home</Link>
            </li>
            <li>
              <a href="#none" onClick={toggleDropdown}>
                컨설팅 서비스<span></span>
              </a>
              <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                <li>
                  <Link to="/GNBPURE01001S">시스템통합(SI)</Link>
                </li>
                <li>
                  <Link to="/GNBPURE01002S">시스템유지보수(SM)</Link>
                </li>
                <li>
                  <Link to="/GNBPURE01003S">솔루션 제공</Link>
                </li>
                <li>
                  <Link to="/GNBPURE01004S">
                    애플리케이션서비스 제공 (ASP)
                  </Link>
                </li>
                <li>
                  <Link to="/GNBPURE01005S">IT컨설팅 서비스</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div id="cont" className="cont">
          <div className="inner">
            <h3>
              IT 컨설팅 서비스
              <br />
              (IT Consulting Services)
            </h3>

            <article>
              <p className="subtitle">GNB & Pure IT컨설팅 서비스</p>
              <p>
                자사가 제공하는 컨설팅 서비스는 20년 이상의 금융 IT 경험을
                바탕으로 기업의 IT환경을 분석하고, 빠르게 변화하는 금융환경에
                맞추어 최적의 전략과 솔루션을 제안하여{" "}
                <strong style={{ color: "red", fontWeight: "bold" }}>
                  비즈니스 경쟁력 강화와 효율적인 IT운영을 지원하는 서비스
                </strong>
                입니다.
              </p>
            </article>

            <article>
              <p className="subtitle">금융기관에 최적화된 IT 컨설팅</p>
              <img src="/asset/img/subB/img_consulting.png" alt="고객 비즈니스 환경에 적합한 최적의 컨설팅 제공" className="vis_img pc" />
              <img src="/asset/img/subB/img_consulting.png" alt="고객 비즈니스 환경에 적합한 최적의 컨설팅 제공" className="mo" />
            </article>

            <div className="table-type table-row mt50">
              <table>
                <caption>컨설팅</caption>
                <colgroup>
                  <col style={{ width: "25%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>

                <tbody>
                  <tr>
                    <th scope="row">20년 이상의 금융 IT 경험</th>
                    <td>
                      <ul className="bul-dot">
                        <li>
                          풍부한 금융업무 지식을 바탕으로, 금융권 IT 환경에
                          최적화된 컨설팅 제공
                        </li>
                        <li>
                          저축은행, 캐피탈, 카드사 등 다양한 금융기관 프로젝트
                          수행 경험
                        </li>
                        <li>저축은행 차세대 시스템 컨설팅 경험</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">변화하는 금융 환경 및 규제 대응 역량</th>
                    <td>
                      <ul className="bul-dot">
                        <li>
                          금융권의 규제 변경, 보안 이슈, 시스템 변화에 대한
                          빠른 대응 가능
                        </li>
                        <li>
                          최신 금융 컴플라이언스 및 보안 솔루션 적용 컨설팅 제공
                        </li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">맞춤형 IT 솔루션 운영 전략 제공</th>
                    <td>
                      <ul className="bul-dot">
                        <li>
                          클라우드, AI, 빅데이터 등 최신 기술을 활용한 금융
                          시스템 컨설팅
                        </li>
                        <li>
                          IT 비용 절감과 운영 효율성을 극대화할 수 있는 최적의
                          솔루션 제안
                        </li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">보안 및 리스크 대응 강화</th>
                    <td>
                      <ul className="bul-dot">
                        <li>
                          금융권의 보안 위협 및 시스템 리스크 사전 대응 컨설팅
                        </li>
                        <li>
                          금융기관의 데이터 보호 및 사이버 보안 강화 전략 제공
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE01005S;
